import config from "../../../config";
import WriteEdit from "./WriteEdit.svg"
import WriteEditWhite from "./WriteEditWhite.svg"
import TrashSvg from "./Trash.svg"
const getFireStoreUrl = (path) => (`https://firebasestorage.googleapis.com/v0/b/yo-americano.appspot.com/o/assets%2F${path}?alt=media&token=6a9a7f5a-4959-431c-a305-8eabe60a4d46`);
const getUrl = (path) => (`https://firebasestorage.googleapis.com/v0/b/yo-americano.appspot.com/o/${path}?alt=media&token=e1a09441-0c55-4be0-a545-d0a579f8d7222`)
const cloud_flare_img = (path) => (`https://imagedelivery.net/B62pqpMZqieDKhv80nP5iw/${path}/public`)

const NoAssignmentCompletedimg = getFireStoreUrl("no_assignment_completed.jpg");
const NoAssignmentPastimg = getFireStoreUrl("no_assignment_past.jpg");
const NoAssignmentTodayimg = getFireStoreUrl("no_assignment_today.jpg");
const NoAssignmentWeekimg = getFireStoreUrl("no_assignment_week.png");
const Worldimg = getFireStoreUrl("world.png");
const Worksheetimg = getFireStoreUrl("worksheet.jpg");
const Apimg = getFireStoreUrl("ap.png");
const Birdimg = getFireStoreUrl("bird.png");
const BoxSettimgimg = getFireStoreUrl("boxsetting.png");
const Calendarimg = getFireStoreUrl("calendar.png");
const CotationBgimg = getFireStoreUrl("cotation_bg.png");
const CotationBgimgNew = getFireStoreUrl("cotation_bg_new.png");
const GraphicOrganizerimg = getFireStoreUrl("graphic_organizer.jpg");
const HarramientsImg = getFireStoreUrl("herramientas.jpg");
const LoadingBgimg = getFireStoreUrl("loading_bg.jpg");
const Logoimg = getFireStoreUrl("logo.jpg");
const mobileMenuimg = getFireStoreUrl("mobile_menu.png");
const NoNotesimg = getFireStoreUrl("no_notes.jpg");
const noQuestionimg = getFireStoreUrl("no_question.png");
const NoDataTeacherGraphimg = getFireStoreUrl("noDataTeacherGraph.png");
const Nostroonlineimg = getFireStoreUrl("nostro_online.jpg");
const NoteIconimg = getFireStoreUrl("note_icon.png");
const UpdatedNoteIcon  =  `https://firebasestorage.googleapis.com/v0/b/yo-americano.appspot.com/o/note-empty-icon.svg?alt=media&token=e1a09441-0c55-4be0-a545-d0a579f8d7222`;
const UpdatedAssignableImg = getUrl("assignable-image.svg")
const UpdatedNoteIconimg =`https://firebasestorage.googleapis.com/v0/b/yo-americano.appspot.com/o/note-icon.svg?alt=media&token=e1a09441-0c55-4be0-a545-d0a579f8d7222`;
const UpdatedAssignedImg = `https://firebasestorage.googleapis.com/v0/b/yo-americano.appspot.com/o/assigned-icon.svg?alt=media&token=e1a09441-0c55-4be0-a545-d0a579f8d7222`;
const IsolationMode =`https://firebasestorage.googleapis.com/v0/b/yo-americano.appspot.com/o/Isolation_Mode.svg?alt=media&token=e1a09441-0c55-4be0-a545-d0a579f8d7222`
const QuestionMarkimg = getFireStoreUrl("question_mark.png");
const ResourceBgimg = getFireStoreUrl("resource_bg.jpg");
const SadEmojiimg = getFireStoreUrl("sad_emoji.png");
const Tbgimg = getFireStoreUrl("tbg.jpg");
const TbgIconimg = getFireStoreUrl("tbg-icon.jpg");
const TrueMarkimg = getFireStoreUrl("true_mark.png");
const VideoCover = getFireStoreUrl("VideoCover.png");
const Ps = getFireStoreUrl("ps.png");
const AuthBG = getFireStoreUrl("AuthBG.png");
const DefaultLogo = getFireStoreUrl("nostro_online.jpg");
const MenuImg = getFireStoreUrl("menuimg.png");
const placeImg = `https://firebasestorage.googleapis.com/v0/b/yo-americano.appspot.com/o/assets%2Fplace.jpg?alt=media&token=647ef082-70d3-4f3e-bc1d-9b55771f97f1`;
const colorImg = `https://firebasestorage.googleapis.com/v0/b/yo-americano.appspot.com/o/assets%2Fcolor.jpg?alt=media&token=c8a8c431-da5a-4f30-861b-d00ef490cf2b`;
const MenuWhiteImg = `https://firebasestorage.googleapis.com/v0/b/yo-americano.appspot.com/o/assets%2Fimageedit_12_3714614806.png?alt=media&token=2c287677-6fbe-4414-9e88-31cbd0a1080c`
const Logo_transparent = "https://firebasestorage.googleapis.com/v0/b/yo-americano.appspot.com/o/Logos%2Flogo_transparent.png?alt=media&token=b0871bf7-069c-4906-9884-68f981cf7ef2"
const LoginBg = "https://firebasestorage.googleapis.com/v0/b/yo-americano.appspot.com/o/login_cover-min.png?alt=media&token=9fa50222-7c1f-4eb1-8e5d-23c722e10c3e"
const IntoVideoDev = "https://owedev-welcome-videos.s3.amazonaws.com/An%C3%A9cdotas_+vida%2Cactualidad+y+cultura.mp4"
const IntoVideoLausd = "https://owedev-welcome-videos.s3.amazonaws.com/intro_video.mp4"
const circural_arrow = "https://firebasestorage.googleapis.com/v0/b/yo-americano.appspot.com/o/assets%2Fcircular_arrow.png?alt=media&token=f5d72608-d06a-4d0b-b313-34847f06fe7b";
const DistrictBg = "https://firebasestorage.googleapis.com/v0/b/yo-americano.appspot.com/o/assets%2Fdistinct_bg.png?alt=media&token=59ccb373-a9a0-41ef-b91d-00f4d5636743";
const SimpleLogo = "https://firebasestorage.googleapis.com/v0/b/yo-americano.appspot.com/o/assets%2Fsimplelogo.png?alt=media&token=faa01b3c-4aa8-4b0a-8f53-cad73b311379"
const Death_Day = "https://firebasestorage.googleapis.com/v0/b/yo-americano.appspot.com/o/assets%2Fhome_logo_1.png?alt=media&token=b74c0654-7eba-4df5-a6b6-f532d47d03e5&_gl=1*10m6fbm*_ga*MTg0Njk4NDQxNS4xNjk3MDAwODI1*_ga_CW55HF8NVT*MTY5OTM0NDQ1NC44LjEuMTY5OTM0NTI2Mi42MC4wLjA."
const home_icon = "https://firebasestorage.googleapis.com/v0/b/yo-americano.appspot.com/o/christmas.png?alt=media&token=32c177f5-6e31-47ff-a515-a36fbb5a4e8b";
const GradCalendar = "https://firebasestorage.googleapis.com/v0/b/yo-americano.appspot.com/o/calendar.png?alt=media&token=e1a09441-0c55-4be0-a545-d0a579f8d7222"
const IntroVideoCover = getFireStoreUrl("intro_video_cover.png");
const Notesicon = getFireStoreUrl("notesicon.png");
const Questionicon = getFireStoreUrl("questionicon.png");
const IntroVideo = config.isDev ? IntoVideoLausd : IntoVideoDev
const IntroVideoPoster = IntroVideoCover
const CologG = getFireStoreUrl("colorG.png");
const TableBg = getFireStoreUrl("tablebg.png")
const BirdLogo = getFireStoreUrl("birdwithtext.png");
const ButtonBg = getFireStoreUrl("buttonbg.png");
const ClassLeftImg = getFireStoreUrl("classleftimg.png");
const ClassLeftNewImg = getUrl("back_classleftimg.png");
const ClassLeftNewLogo = getUrl("classleft_logo.png");
const BirdLogoLarge = getFireStoreUrl("BIRDLOGO.png");
const SelectArrow = getFireStoreUrl("selectArrow.png");
const Pic1 = getFireStoreUrl("pic1.jpeg");
const blogbanner = getFireStoreUrl("blogbanner.jpg");
const img34 = getFireStoreUrl("34.png");
const backBg = getFireStoreUrl("backBg.png");
const blog = getFireStoreUrl("blog.jpeg");
const bloglink = getFireStoreUrl("blogLink.png");
const btnBg = getFireStoreUrl("btnBg.png");
const closeicon = getFireStoreUrl("closeIcon.png");
const closeModal = getFireStoreUrl("closeModel.png");
const editIcon = getFireStoreUrl("editIcon.png");
const globeBg3 = getFireStoreUrl("globeBg3.png");
const learnImg = getFireStoreUrl("learnImg.jpg");
const locationImg = getFireStoreUrl("location.png");
const locationResource = getFireStoreUrl("locationResource.png");
const LOGO = getFireStoreUrl("LOGO.png");
const modalBanner = getFireStoreUrl("modalBanner.jpeg");
const nostroOnline = getFireStoreUrl("nostroOnline.jpg");
const profileArrow = getFireStoreUrl("profileArrow.png");
const resource1 = getFireStoreUrl("resource1.png");
const userImg = getFireStoreUrl("user.png");
const videoBlog = getFireStoreUrl("videoBlog.png");
const videoImg = getFireStoreUrl("videoImg.png");
const videoLink = getFireStoreUrl("videoLink.png");
const bubbleNotes = getUrl("bubble_note.png");
const rootImage = `https://firebasestorage.googleapis.com/v0/b/yo-americano.appspot.com/o/assets%2Frobert.jpg?alt=media&token=cabe0039-a258-4863-888a-abba90a994b2`
const bootImg = `https://firebasestorage.googleapis.com/v0/b/yo-americano.appspot.com/o/assets%2Fboot.jpg?alt=media&token=0f1993a2-dcac-4967-9b3c-45c423cb7ed8`
const AIimg = `https://firebasestorage.googleapis.com/v0/b/yo-americano.appspot.com/o/assets%2FAI.jpg?alt=media&token=b223d31e-6dd9-4c3f-b456-350c90c02ec9`
const searchIconImage = `https://firebasestorage.googleapis.com/v0/b/yo-americano.appspot.com/o/assets%2FsearchIcon.png?alt=media&token=beaf5a4c-ea94-4030-9770-e6738c071a32`
const LogoOnExam = cloud_flare_img('d46eb13e-8a10-4c79-ec42-23c53f538400');
const SearchIcon = `https://firebasestorage.googleapis.com/v0/b/yo-americano.appspot.com/o/assets%2Fsearch.png?alt=media&token=bbbf3422-4b31-4c95-a7cf-794bb4d0d247`
const MenuIcon = `https://firebasestorage.googleapis.com/v0/b/yo-americano.appspot.com/o/assets%2Fmenu.png?alt=media&token=3c732e0c-9fd8-4fbe-8775-b57c2818db59`
const MessageBottal = `https://firebasestorage.googleapis.com/v0/b/yo-americano.appspot.com/o/chat%2FmessageBottal.png?alt=media&token=d7cddf37-96a9-4788-a960-4f622c16ec94`
const MessageRocket = `https://firebasestorage.googleapis.com/v0/b/yo-americano.appspot.com/o/chat%2FmessageRocket.png?alt=media&token=2828d72d-c484-4667-8280-e255a97bb099`
const TransparentLogoWhite = `https://firebasestorage.googleapis.com/v0/b/yo-americano.appspot.com/o/chat%2FtransparentLogo.png?alt=media&token=76a67577-0cd6-4aca-9a17-16da58c62480`
const CatImg = `https://firebasestorage.googleapis.com/v0/b/yo-americano.appspot.com/o/chat%2Fcat_av.jpeg?alt=media&token=5ff24895-96f2-4831-b8c2-d17c064f9a0e`
const CalendarIcon = `https://firebasestorage.googleapis.com/v0/b/yo-americano.appspot.com/o/chat%2Fcalendar%20.png?alt=media&token=9b3f3072-a798-47d1-8173-692e7f8fd94f`;
const ClockIcon = `https://firebasestorage.googleapis.com/v0/b/yo-americano.appspot.com/o/chat%2Fclock.png?alt=media&token=150ed32d-3a2a-493a-93f9-ef1e7c7dcd3d`
const MobIcon = `https://firebasestorage.googleapis.com/v0/b/yo-americano.appspot.com/o/chat%2Fmob.png?alt=media&token=a201f5b9-76e9-4d36-9f67-9bd920a2c712`
const IMG_7614 = `https://imagedelivery.net/B62pqpMZqieDKhv80nP5iw/17093ddb-3dc2-429a-b8b4-e64321acc000/public`
const IMG_7611 = `https://imagedelivery.net/B62pqpMZqieDKhv80nP5iw/2cca36ea-d17b-4166-50c3-98641d319800/public`
const IMG_7605 = `https://imagedelivery.net/B62pqpMZqieDKhv80nP5iw/3d50bcf9-da85-47ed-0f22-3b497ae7fd00/public`
const IMG_7600 = `https://imagedelivery.net/B62pqpMZqieDKhv80nP5iw/4dcfa429-1518-4da0-a51e-1381d8f53c00/public`
const IMG_7596 = `https://imagedelivery.net/B62pqpMZqieDKhv80nP5iw/abfa3137-9079-4228-2ad9-9807133ce800/public`
const IMG_7595 = `https://imagedelivery.net/B62pqpMZqieDKhv80nP5iw/5fd14401-cc5a-44ff-ca6a-0a18085eef00/public`
const IMG_7577 = `https://imagedelivery.net/B62pqpMZqieDKhv80nP5iw/81c48cae-fcff-4ac0-023d-b04b75fee800/public`
const IMG_7576 = `https://imagedelivery.net/B62pqpMZqieDKhv80nP5iw/f4a51012-4693-4d40-9964-d41ee0343f00/public`
const IMG_7575 = `https://imagedelivery.net/B62pqpMZqieDKhv80nP5iw/d02423f8-b174-407a-7dd8-ce7db7320a00/public`
const IMG_7574 = `https://imagedelivery.net/B62pqpMZqieDKhv80nP5iw/3460569d-06b4-4010-c23d-220567dd8300/public`
const uploadImg = "https://firebasestorage.googleapis.com/v0/b/yo-americano.appspot.com/o/chat%2Fupload.jpeg?alt=media&token=75695184-ee4f-47e0-994e-0554adbb8e4a"
const threeDotImg = `https://firebasestorage.googleapis.com/v0/b/yo-americano.appspot.com/o/assets%2Fthreedots.png?alt=media&token=5eeb8f48-dd5a-47ce-9966-53f0208fbacd`
const LoginLogo = cloud_flare_img('4fe3d8d2-0005-42b8-9a88-2896c8c3bb00')
const StarRating = cloud_flare_img('26f9b1d3-a9a2-4553-a0f0-5e750be10100')
const personGreen2 = 'https://firebasestorage.googleapis.com/v0/b/yo-americano.appspot.com/o/assets%2FpersonGreen2.png?alt=media&token=a0376a4a-c0b5-47ed-9421-0fe2ec62a86c'
const personGreen1 = 'https://firebasestorage.googleapis.com/v0/b/yo-americano.appspot.com/o/assets%2FpersonGreen1.png?alt=media&token=75f53aa8-1d80-43d5-ab3d-b4e1b709a946'
const WheelImg = `https://firebasestorage.googleapis.com/v0/b/yo-americano.appspot.com/o/assets%2F146.png?alt=media&token=2b19792a-1a6d-4e50-a0a1-a614eb0905fe`
const WheelTransparentImg = `https://firebasestorage.googleapis.com/v0/b/yo-americano.appspot.com/o/assets%2Fwheel_transparent.png?alt=media&token=856fa8c6-f1d0-4ec2-bb0a-615746400831`
const WheelClock = `https://firebasestorage.googleapis.com/v0/b/yo-americano.appspot.com/o/assets%2Fclock-bg.png?alt=media&token=7693d603-1a84-4e84-bb10-0ed41b9602ef`
const colorCircle = `https://firebasestorage.googleapis.com/v0/b/yo-americano.appspot.com/o/assets%2FcolorCircle.png?alt=media&token=f3b1b390-a5a1-4a31-8d20-af6e31dab6a4`
const robert2 = `https://firebasestorage.googleapis.com/v0/b/yo-americano.appspot.com/o/assets%2FA2%20-%20GRAPHIC%20ORGANIZERS.png?alt=media&token=161fe3dc-3b30-492d-a67c-e68c83d6a77c`
const datagrid_close = `https://firebasestorage.googleapis.com/v0/b/yo-americano.appspot.com/o/assets%2Fdatagrid%2Fclose.png?alt=media&token=775a9f9b-600f-4110-b639-cef31d62a048`;
const datagrid_logo = `https://firebasestorage.googleapis.com/v0/b/yo-americano.appspot.com/o/assets%2Fdatagrid%2Flogo.png?alt=media&token=775a9f9b-600f-4110-b639-cef31d62a048`;
const datagrid_colorCombo = `https://firebasestorage.googleapis.com/v0/b/yo-americano.appspot.com/o/assets%2Fdatagrid%colorCombo.jpg?alt=media&token=775a9f9b-600f-4110-b639-cef31d62a048`;
const datagrid_searchIcon = `https://firebasestorage.googleapis.com/v0/b/yo-americano.appspot.com/o/assets%2Fdatagrid%2FsearchIcon.png?alt=media&token=83bbc5a4-bb2a-4cf2-a552-e3134eb81545`;
const datagrid_eyeIcon = `https://firebasestorage.googleapis.com/v0/b/yo-americano.appspot.com/o/assets%2Fdatagrid%2FeyeIcon.png?alt=media&token=056408b8-b1d8-4607-949c-eca2e54ce75f`;
const datagrid_logoColored = `https://firebasestorage.googleapis.com/v0/b/yo-americano.appspot.com/o/assets%2Fdatagrid%2FlogoColored.png?alt=media&token=7ba15483-64ea-4bdc-a8ad-b13a6e41df12`;
const pic11 = `https://firebasestorage.googleapis.com/v0/b/yo-americano.appspot.com/o/assets%2Fpic11.jpg?alt=media&token=d497d1e2-a6d9-48c8-9cb0-5f7ac49eeb47`;
const pic22 = `https://firebasestorage.googleapis.com/v0/b/yo-americano.appspot.com/o/assets%2Fpic22.jpg?alt=media&token=d497d1e2-a6d9-48c8-9cb0-5f7ac49eeb47`;
const pic33 = `https://firebasestorage.googleapis.com/v0/b/yo-americano.appspot.com/o/assets%2Fpic33.jpg?alt=media&token=d497d1e2-a6d9-48c8-9cb0-5f7ac49eeb47`;
const pic44 = `https://firebasestorage.googleapis.com/v0/b/yo-americano.appspot.com/o/assets%2Fpic44.jpg?alt=media&token=d497d1e2-a6d9-48c8-9cb0-5f7ac49eeb47`;
const pic55 = `https://firebasestorage.googleapis.com/v0/b/yo-americano.appspot.com/o/assets%2Fpic55.jpg?alt=media&token=d497d1e2-a6d9-48c8-9cb0-5f7ac49eeb47`;
const DueTodayIcon = `https://firebasestorage.googleapis.com/v0/b/yo-americano.appspot.com/o/assets%2F31.png?alt=media&token=800ef2d4-654f-4633-84fd-c308c7d801b0`
const PastDueTodayIcon = `https://firebasestorage.googleapis.com/v0/b/yo-americano.appspot.com/o/assets%2F32.png?alt=media&token=9ba771c0-6367-4149-9ede-742703f56083`

const IGameAI = 'https://firebasestorage.googleapis.com/v0/b/yo-americano.appspot.com/o/1game%2Fai.png?alt=media&token=aab2bab4-4996-4df5-be39-85fb5bbb27ef&_gl=1*15oz94y*_ga*MTg0Njk4NDQxNS4xNjk3MDAwODI1*_ga_CW55HF8NVT*MTY5NzAwMDgyNS4xLjEuMTY5NzAwMDk1Ny45LjAuMA'
const IGameHome10 = 'https://firebasestorage.googleapis.com/v0/b/yo-americano.appspot.com/o/1game%2Fimg24.jpg?alt=media&token=aab2bab4-4996-4df5-be39-85fb5bbb27ef&_gl=1*15oz94y*_ga*MTg0Njk4NDQxNS4xNjk3MDAwODI1*_ga_CW55HF8NVT*MTY5NzAwMDgyNS4xLjEuMTY5NzAwMDk1Ny45LjAuMA'
const IGameHome7 = 'https://firebasestorage.googleapis.com/v0/b/yo-americano.appspot.com/o/1game%2Fimg21.jpg?alt=media&token=aab2bab4-4996-4df5-be39-85fb5bbb27ef&_gl=1*15oz94y*_ga*MTg0Njk4NDQxNS4xNjk3MDAwODI1*_ga_CW55HF8NVT*MTY5NzAwMDgyNS4xLjEuMTY5NzAwMDk1Ny45LjAuMA'
const IGameHome8 = 'https://firebasestorage.googleapis.com/v0/b/yo-americano.appspot.com/o/1game%2Fimg22.jpg?alt=media&token=aab2bab4-4996-4df5-be39-85fb5bbb27ef&_gl=1*15oz94y*_ga*MTg0Njk4NDQxNS4xNjk3MDAwODI1*_ga_CW55HF8NVT*MTY5NzAwMDgyNS4xLjEuMTY5NzAwMDk1Ny45LjAuMA'
const IGameHome9 = 'https://firebasestorage.googleapis.com/v0/b/yo-americano.appspot.com/o/1game%2Fimg23.jpg?alt=media&token=aab2bab4-4996-4df5-be39-85fb5bbb27ef&_gl=1*15oz94y*_ga*MTg0Njk4NDQxNS4xNjk3MDAwODI1*_ga_CW55HF8NVT*MTY5NzAwMDgyNS4xLjEuMTY5NzAwMDk1Ny45LjAuMA'
const IGameLogo = 'https://firebasestorage.googleapis.com/v0/b/yo-americano.appspot.com/o/1game%2FGameLogo.jpg?alt=media&token=aab2bab4-4996-4df5-be39-85fb5bbb27ef&_gl=1*15oz94y*_ga*MTg0Njk4NDQxNS4xNjk3MDAwODI1*_ga_CW55HF8NVT*MTY5NzAwMDgyNS4xLjEuMTY5NzAwMDk1Ny45LjAuMA'
const IGameModalImg = 'https://firebasestorage.googleapis.com/v0/b/yo-americano.appspot.com/o/1game%2Fdecktop.png?alt=media&token=aab2bab4-4996-4df5-be39-85fb5bbb27ef&_gl=1*15oz94y*_ga*MTg0Njk4NDQxNS4xNjk3MDAwODI1*_ga_CW55HF8NVT*MTY5NzAwMDgyNS4xLjEuMTY5NzAwMDk1Ny45LjAuMA'
const IGameModalImgDeck = 'https://firebasestorage.googleapis.com/v0/b/yo-americano.appspot.com/o/1game%2Fbg1.jpg?alt=media&token=aab2bab4-4996-4df5-be39-85fb5bbb27ef&_gl=1*15oz94y*_ga*MTg0Njk4NDQxNS4xNjk3MDAwODI1*_ga_CW55HF8NVT*MTY5NzAwMDgyNS4xLjEuMTY5NzAwMDk1Ny45LjAuMA'
const IGameModalImgMobile = 'https://firebasestorage.googleapis.com/v0/b/yo-americano.appspot.com/o/1game%2Fmobile.png?alt=media&token=aab2bab4-4996-4df5-be39-85fb5bbb27ef&_gl=1*15oz94y*_ga*MTg0Njk4NDQxNS4xNjk3MDAwODI1*_ga_CW55HF8NVT*MTY5NzAwMDgyNS4xLjEuMTY5NzAwMDk1Ny45LjAuMA'
const IGameModalTab = 'https://firebasestorage.googleapis.com/v0/b/yo-americano.appspot.com/o/1game%2FtabImg.png?alt=media&token=aab2bab4-4996-4df5-be39-85fb5bbb27ef&_gl=1*15oz94y*_ga*MTg0Njk4NDQxNS4xNjk3MDAwODI1*_ga_CW55HF8NVT*MTY5NzAwMDgyNS4xLjEuMTY5NzAwMDk1Ny45LjAuMA'
const IGameRightTick = 'https://firebasestorage.googleapis.com/v0/b/yo-americano.appspot.com/o/1game%2Fright.jpg?alt=media&token=aab2bab4-4996-4df5-be39-85fb5bbb27ef&_gl=1*15oz94y*_ga*MTg0Njk4NDQxNS4xNjk3MDAwODI1*_ga_CW55HF8NVT*MTY5NzAwMDgyNS4xLjEuMTY5NzAwMDk1Ny45LjAuMA'
const IGameHome11 = 'https://firebasestorage.googleapis.com/v0/b/yo-americano.appspot.com/o/1game%2Fimg25.jpg?alt=media&token=aab2bab4-4996-4df5-be39-85fb5bbb27ef&_gl=1*15oz94y*_ga*MTg0Njk4NDQxNS4xNjk3MDAwODI1*_ga_CW55HF8NVT*MTY5NzAwMDgyNS4xLjEuMTY5NzAwMDk1Ny45LjAuMA'
// const StudyTest = 'https://firebasestorage.googleapis.com/v0/b/yo-americano.appspot.com/o/1game%2Fstudytest.png?alt=media&token=aab2bab4-4996-4df5-be39-85fb5bbb27ef&_gl=1*15oz94y*_ga*MTg0Njk4NDQxNS4xNjk3MDAwODI1*_ga_CW55HF8NVT*MTY5NzAwMDgyNS4xLjEuMTY5NzAwMDk1Ny45LjAuMA'
const AIBook = 'https://firebasestorage.googleapis.com/v0/b/yo-americano.appspot.com/o/AI_Book.png?alt=media&token=e1a09441-0c55-4be0-a545-d0a579f8d7222';
const AITopic = 'https://firebasestorage.googleapis.com/v0/b/yo-americano.appspot.com/o/AI_Topic.png?alt=media&token=e1a09441-0c55-4be0-a545-d0a579f8d7222';

const ChatMenue = `https://firebasestorage.googleapis.com/v0/b/yo-americano.appspot.com/o/assets%2FChat_Icon.jpg?alt=media&token=2b19792a-1a6d-4e50-a0a1-a614eb0905fe`;
const Questions = `https://firebasestorage.googleapis.com/v0/b/yo-americano.appspot.com/o/assets%2FQuestion_icon.jpg?alt=media&token=2b19792a-1a6d-4e50-a0a1-a614eb0905fe`;
const Notes = `https://firebasestorage.googleapis.com/v0/b/yo-americano.appspot.com/o/assets%2FNotes_icon.jpg?alt=media&token=2b19792a-1a6d-4e50-a0a1-a614eb0905fe`;
const Notification = `https://firebasestorage.googleapis.com/v0/b/yo-americano.appspot.com/o/assets%2FNotification_Icon.jpg?alt=media&token=2b19792a-1a6d-4e50-a0a1-a614eb0905fe`;
const oneWayLessonsBalcon = `https://firebasestorage.googleapis.com/v0/b/yo-americano.appspot.com/o/assets%2FBalcon_cultural.jpg?alt=media&token=2b19792a-1a6d-4e50-a0a1-a614eb0905fe`;
const oneWayLessonsConectandome = `https://firebasestorage.googleapis.com/v0/b/yo-americano.appspot.com/o/assets%2FConectandome_Cover.jpg?alt=media&token=2b19792a-1a6d-4e50-a0a1-a614eb0905fe`;
const oneWayLessonsComunidad = `https://firebasestorage.googleapis.com/v0/b/yo-americano.appspot.com/o/assets%2FComunidad_cover.jpg?alt=media&token=2b19792a-1a6d-4e50-a0a1-a614eb0905fe`;
const IdeaOneWay = `https://firebasestorage.googleapis.com/v0/b/yo-americano.appspot.com/o/idea1.png?alt=media&token=1809af4d-ebbe-437e-ae33-6088891bc72f`
const IdeaAi = `https://firebasestorage.googleapis.com/v0/b/yo-americano.appspot.com/o/AiImg.png?alt=media&token=c2ad5451-5f0a-48e4-9aba-267214075739`
const GameLogo = `https://firebasestorage.googleapis.com/v0/b/yo-americano.appspot.com/o/1game%2FGameLogo.jpg?alt=media&token=aab2bab4-4996-4df5-be39-85fb5bbb27ef`
const CheckListImg = `https://firebasestorage.googleapis.com/v0/b/yo-americano.appspot.com/o/checklistImg.webp?alt=media&token=c2ad5451-5f0a-48e4-9aba-267214075739`
const AIfeebackImage = `https://firebasestorage.googleapis.com/v0/b/yo-americano.appspot.com/o/assets%2Fai_ico.png?alt=media&token=c48f0aa0-0bab-4cd8-822f-b47158829b3a`
const AiFeedbackImage = `https://firebasestorage.googleapis.com/v0/b/yo-americano.appspot.com/o/roboAISuggest.png?alt=media&token=e1a09441-0c55-4be0-a545-d0a579f8d7222`;

const DUMMY_POSTER = `https://firebasestorage.googleapis.com/v0/b/yo-americano.appspot.com/o/assets%2Fpreview_blank_image.webp?alt=media&token=fd60ec0e-7479-42e4-b05b-59cfc75113ba`
// const Debate = `https://firebasestorage.googleapis.com/v0/b/yo-americano.appspot.com/o/one-way-debate.png?alt=media&token=e1a09441-0c55-4be0-a545-d0a579f8d7222`;
const DebateLftIcon = `https://firebasestorage.googleapis.com/v0/b/yo-americano.appspot.com/o/flipArrowLeft.png?alt=media&token=e1a09441-0c55-4be0-a545-d0a579f8d7222`;
const DebateRgtIcon = `https://firebasestorage.googleapis.com/v0/b/yo-americano.appspot.com/o/flipArrowRight.png?alt=media&token=e1a09441-0c55-4be0-a545-d0a579f8d7222`;
const EditDebate =`https://firebasestorage.googleapis.com/v0/b/yo-americano.appspot.com/o/editdebate.jpg?alt=media&token=e1a09441-0c55-4be0-a545-d0a579f8d7222`;
// const DebateOneWayLogo =`https://firebasestorage.googleapis.com/v0/b/yo-americano.appspot.com/o/debateWith1Way_Logo.png?alt=media&token=e1a09441-0c55-4be0-a545-d0a579f8d7222`;
const DebateNewLogo = `https://firebasestorage.googleapis.com/v0/b/yo-americano.appspot.com/o/debateNew_Logo1.png?alt=media&token=e1a09441-0c55-4be0-a545-d0a579f8d7222`
const DebateComment = cloud_flare_img('ad407c06-0d9a-4cc6-e496-c952c1329600')
export const AbsentSvg  = `https://firebasestorage.googleapis.com/v0/b/yo-americano.appspot.com/o/Logos%2Fabsent.svg?alt=media&token=f31dddc8-9de3-4ee5-b1e6-3450e68c07fd`
export const LateSvg = `https://firebasestorage.googleapis.com/v0/b/yo-americano.appspot.com/o/Logos%2Flate.svg?alt=media&token=ca23390b-96f9-4ff2-9196-a89b3ab8f8ae`
export const Pinpoint = `https://firebasestorage.googleapis.com/v0/b/yo-americano.appspot.com/o/Logos%2FpinIcon2.png?alt=media&token=9523516f-de6b-4cef-afae-9c9f1e33cba6`
export const study1gameLogo = `https://firebasestorage.googleapis.com/v0/b/yo-americano.appspot.com/o/studyLogos.png?alt=media&token=e1a09441-0c55-4be0-a545-d0a579f8d7222`
export const debatePoster = `https://firebasestorage.googleapis.com/v0/b/yo-americano.appspot.com/o/assets%2FGRADEBOOK%20DEBATE%20VIEW.png?alt=media&token=48ffbe1c-a318-4d96-ac76-2af6f2ecaa6b`
export const message_alert_bg1 = `https://firebasestorage.googleapis.com/v0/b/yo-americano.appspot.com/o/alert_message_bg1.jpg?alt=media&token=5b8815b5-4867-4b32-9abd-c60357302b66`
export const message_alert_bg2 = `https://firebasestorage.googleapis.com/v0/b/yo-americano.appspot.com/o/alert_message_bg2.jpg?alt=media&token=5b8815b5-4867-4b32-9abd-c60357302b66`
export const message_alert_bg3 = `https://firebasestorage.googleapis.com/v0/b/yo-americano.appspot.com/o/alert_message_bg3.jpg?alt=media&token=5b8815b5-4867-4b32-9abd-c60357302b66`
export const noise_meter_icon = `https://firebasestorage.googleapis.com/v0/b/yo-americano.appspot.com/o/assets%2Ficons%2Fnoise_meter_icon.png?alt=media&token=77b59904-f372-45ce-9612-7fa2eb79db08`
export const ClocksImg = `https://firebasestorage.googleapis.com/v0/b/yo-americano.appspot.com/o/clockImg.webp?alt=media&token=c2ad5451-5f0a-48e4-9aba-267214075739`
export const ExpressionImg = `https://firebasestorage.googleapis.com/v0/b/yo-americano.appspot.com/o/expressionmg.webp?alt=media&token=c2ad5451-5f0a-48e4-9aba-267214075739`
export const DownArrowImg = `https://firebasestorage.googleapis.com/v0/b/yo-americano.appspot.com/o/downArrowmg.png?alt=media&token=c2ad5451-5f0a-48e4-9aba-267214075739`
export const birdLogoImg = `https://firebasestorage.googleapis.com/v0/b/yo-americano.appspot.com/o/birdmgLogo.png?alt=media&token=c2ad5451-5f0a-48e4-9aba-267214075739`
export const newIdeas = `https://firebasestorage.googleapis.com/v0/b/yo-americano.appspot.com/o/newIdeas.png?alt=media&token=c2ad5451-5f0a-48e4-9aba-267214075739`
export const newDebates = `https://firebasestorage.googleapis.com/v0/b/yo-americano.appspot.com/o/newDebate.png?alt=media&token=c2ad5451-5f0a-48e4-9aba-267214075739`
export const newChats = `https://firebasestorage.googleapis.com/v0/b/yo-americano.appspot.com/o/newChats.png?alt=media&token=c2ad5451-5f0a-48e4-9aba-267214075739`
export const trafficAudio = `https://firebasestorage.googleapis.com/v0/b/yo-americano.appspot.com/o/light-sound.mp3?alt=media&token=e1a09441-0c55-4be0-a545-d0a579f8d7222`
export const femaleAI = `https://firebasestorage.googleapis.com/v0/b/yo-americano.appspot.com/o/femaleAI.webp?alt=media&token=5b8815b5-4867-4b32-9abd-c60357302b66`
export const maleAI = `https://firebasestorage.googleapis.com/v0/b/yo-americano.appspot.com/o/maleAI.webp?alt=media&token=5b8815b5-4867-4b32-9abd-c60357302b66`
const MascotImage = 'https://firebasestorage.googleapis.com/v0/b/yo-americano.appspot.com/o/Mascot.png?alt=media&token=e1a09441-0c55-4be0-a545-d0a579f8d7222';
const GroupImage = 'https://firebasestorage.googleapis.com/v0/b/yo-americano.appspot.com/o/Group.svg?alt=media&token=e1a09441-0c55-4be0-a545-d0a579f8d7222';
const FeaturesImage = 'https://firebasestorage.googleapis.com/v0/b/yo-americano.appspot.com/o/features.svg?alt=media&token=e1a09441-0c55-4be0-a545-d0a579f8d7222';
export const birdCloude = cloud_flare_img('4c8dd0d7-ed82-40e0-61d6-cc138a321c00');
export const userRobert = cloud_flare_img('15935d34-d0fe-4f9f-9a10-f65940b2ac00');
export const quoteLeft = cloud_flare_img('d289a2a9-df01-4b49-cbfd-60ad2b359700');
export const quoteRight = cloud_flare_img('bb8096ce-48b4-431a-cb45-4634ea665600');
export const PlacementSectionNumberBg = cloud_flare_img('90d6ebcd-9099-4443-c16a-2aaed4c94a00')
export const PlacementExamStopIcon = cloud_flare_img('1f6c75fe-e688-407b-3095-26c4704d1600')
export const studentQuestionImg = cloud_flare_img('65156036-2dce-42a7-a646-cdbb8fadb200');
export const StudentArrowImg = cloud_flare_img('02811185-d0ab-4f1a-a139-f1018c253300');
export const placement_exam_logo =  cloud_flare_img('eec6c43e-f1f7-42d5-23e2-8af137c26d00');
export const placement_district_logo = cloud_flare_img('93da1e6a-a394-4a3a-5df9-d5b21cf1a800');
export const placement_next_logo = cloud_flare_img('93d6a75f-7dcb-4e15-d9ec-90802b584200')

// Play For Fun & Play For Grade Icons
export const nothingToSee = cloud_flare_img('4adfb459-ffe2-49fa-acdc-bdaf311cb000');
export const playForFunIcon = cloud_flare_img('d576d434-0688-48fe-458c-271623eb7c00');
export const playForGradeIcon = cloud_flare_img('281bef3f-b2b9-4b69-8613-c24d512ab000');
export const CreateQuizIcon = cloud_flare_img('89032aeb-2768-43eb-a095-446811cb6000');
export const CreateFlashCardIcon = cloud_flare_img('411cb0f6-6655-431e-7a98-8d69b26fc900');
export const studyGamePreview = cloud_flare_img('dd2244e3-dee5-4696-96c8-bf51f7bba800');
export const studyBlankTemplate = cloud_flare_img('6ddc15d3-1675-41f6-c683-3ddd6ec57000');
export const AiGeneratedBook = cloud_flare_img('3d773885-3e2f-41e0-3cd6-8d67b822a800');
export const AiGeneratedTopic = cloud_flare_img('1463c687-86a7-4841-2f79-f3c2358fb400');
export const studyTutorialIcon = cloud_flare_img('ea12bcef-9a7d-412d-1cf0-9c6e50178200');
export const studyUpdateIcon = cloud_flare_img('4823e530-7502-4e40-f432-88b75cc7c700');
export const ModernGame = cloud_flare_img('2b78110c-fe93-4e5f-2216-6efb9b3ebb00');
export const ClassicGames = cloud_flare_img('191182d0-cee7-49c3-a332-aae911808200');
export const SoyHistorias = cloud_flare_img('4c0a32e6-41a9-46cb-4eaa-3c049724f600');
export const SoyHistoriasNew = cloud_flare_img('c89b1765-d7c9-40c8-a15a-2f72e13aee00');
export const SoyStoryImg = cloud_flare_img('cd562708-164f-4b1a-733a-5fe7bdd81c00')
export const GrammarDrillCover = cloud_flare_img('eae0612c-a8b8-46c9-5693-abde6bf41200');
export const NoAssignmentGraph = cloud_flare_img('2ef7d53d-edbe-42fd-efed-15c6b6440e00');
export const articleLevelCover = `https://imagedelivery.net/B62pqpMZqieDKhv80nP5iw/2ba20f58-eff2-40bf-b316-646c58a5aa00/public`;

const WowAnimation =
  "https://firebasestorage.googleapis.com/v0/b/yo-americano.appspot.com/o/wow_animation.mp3?alt=media&token=e1a09441-0c55-4be0-a545-d0a579f8d7222";
const VideoGameDeath =
  "https://firebasestorage.googleapis.com/v0/b/yo-americano.appspot.com/o/videogame_death_sound.mp3?alt=media&token=e1a09441-0c55-4be0-a545-d0a579f8d7222";
const SinisterLaugh =
  "https://firebasestorage.googleapis.com/v0/b/yo-americano.appspot.com/o/sinister_laugh.mp3?alt=media&token=e1a09441-0c55-4be0-a545-d0a579f8d7222";
const PunchSound =
  "https://firebasestorage.googleapis.com/v0/b/yo-americano.appspot.com/o/punch_6.mp3?alt=media&token=e1a09441-0c55-4be0-a545-d0a579f8d7222";
const WrongAnswerSound =
  'https://firebasestorage.googleapis.com/v0/b/yo-americano.appspot.com/o/wrong-answer-129254.mp3?alt=media&token=a5648eb9-ea13-41aa-8540-65a6f0b63697';
const NextLevelSound =
  "https://firebasestorage.googleapis.com/v0/b/yo-americano.appspot.com/o/next_level.mp3?alt=media&token=e1a09441-0c55-4be0-a545-d0a579f8d7222";
const multiPopSound =
  "https://firebasestorage.googleapis.com/v0/b/yo-americano.appspot.com/o/multi_pop_1.mp3?alt=media&token=e1a09441-0c55-4be0-a545-d0a579f8d7222";
const HappyPopSound =
  "https://firebasestorage.googleapis.com/v0/b/yo-americano.appspot.com/o/happy_pop_2.mp3?alt=media&token=e1a09441-0c55-4be0-a545-d0a579f8d7222";
const gameSplash =
  "https://firebasestorage.googleapis.com/v0/b/yo-americano.appspot.com/o/game_splash.mp3?alt=media&token=e1a09441-0c55-4be0-a545-d0a579f8d7222";
  // const cars1 = `https://firebasestorage.googleapis.com/v0/b/yo-americano.appspot.com/o/books%2FAudioPicker%2F2025-04-18-80e502e2-915f-421c-af44-c84ec02e7c04tunetank.com_call-and-response-alien-technology.wav?alt=media&token=3b93542c-6e02-47dc-8d3d-fe23dde38ee3`;
  // const cars2 = `https://firebasestorage.googleapis.com/v0/b/yo-americano.appspot.com/o/books%2FAudioPicker%2F2025-04-18-3121680a-40ba-41db-9e4c-e9f728d98a15tunetank.com_cartoon-running-metal-wobble.wav?alt=media&token=f0c3b872-e04b-4b21-9355-60d67f373b2e`;
  // const cars3 = `https://firebasestorage.googleapis.com/v0/b/yo-americano.appspot.com/o/books%2FAudioPicker%2F2025-04-18-4ebfe07b-0862-4c43-b487-be4779a22533tunetank.com_run-blender-kitchen.wav?alt=media&token=45549618-5765-420e-bfb2-aebf42f7370e`;
  // const wman1 = `https://firebasestorage.googleapis.com/v0/b/yo-americano.appspot.com/o/books%2FAudioPicker%2F2025-04-18-71182c1a-ea54-48be-a4ca-488a302b6507tunetank.com_funny-bouncing2.wav?alt=media&token=10f4e65e-c4c2-4370-a962-4684c8cfdea7`;
  // const wman2 = `https://firebasestorage.googleapis.com/v0/b/yo-americano.appspot.com/o/books%2FAudioPicker%2F2025-04-18-ba6e16f9-c9ad-4e79-af4c-810ae7698651tunetank.com_funny-bouncing3.wav?alt=media&token=050a1263-e1c4-433d-b2b9-f36d9c7f1fe4`;
  // const wman3 = `https://firebasestorage.googleapis.com/v0/b/yo-americano.appspot.com/o/books%2FAudioPicker%2F2025-04-18-4d223554-ea35-427f-942a-22529644835etunetank.com_perfect!-and-fanfare.wav?alt=media&token=62df3fc8-2a4e-4a37-91d5-4f551ba89b23`;
  // const wman4 = `https://firebasestorage.googleapis.com/v0/b/yo-americano.appspot.com/o/books%2FAudioPicker%2F2025-04-18-763f04b1-33d0-4c41-adfb-54ca97b214a9tunetank.com_trumpet-fanfare-success.wav?alt=media&token=06e20073-ddc8-4ae0-9e53-70e22a67fe12`;
  // const wman5 = `https://firebasestorage.googleapis.com/v0/b/yo-americano.appspot.com/o/books%2FAudioPicker%2F2025-04-18-e8bf3aad-7a92-4c13-8f02-128e2ff2034ctunetank.com_whistle-funny-siren.wav?alt=media&token=57d0cff9-65f4-4fc2-8e4d-aed3a6b3abd7`;
  // const wman6 = `https://firebasestorage.googleapis.com/v0/b/yo-americano.appspot.com/o/books%2FAudioPicker%2F2025-04-18-ce3537ed-f3f9-4013-950e-016ebb29349ftunetank.com_winner-trumpet-fanfare.wav?alt=media&token=6c4a5365-795c-4792-bbde-7d86ff1fd592`;
const cars1 = "https://firebasestorage.googleapis.com/v0/b/yo-americano.appspot.com/o/tunetank.com_call-and-response-alien-technology.mp3?alt=media&token=77a8286a-61a7-4dd9-8a8c-937ad4a1f1d9";
const cars2 = "https://firebasestorage.googleapis.com/v0/b/yo-americano.appspot.com/o/tunetank.com_cartoon-running-metal-wobble.mp3?alt=media&token=38198ea4-b1bd-4acc-8de1-90969952393b";
const cars3 = "https://firebasestorage.googleapis.com/v0/b/yo-americano.appspot.com/o/tunetank.com_run-blender-kitchen.mp3?alt=media&token=78a8650d-29cc-4c3e-ab45-74cc3ff23e40";
const wman1 = "https://firebasestorage.googleapis.com/v0/b/yo-americano.appspot.com/o/tunetank.com_funny-bouncing2.mp3?alt=media&token=a7a32761-1114-49cd-9530-9b1094cc54f6";
const wman2 = "https://firebasestorage.googleapis.com/v0/b/yo-americano.appspot.com/o/tunetank.com_funny-bouncing3.mp3?alt=media&token=d830c390-11a1-417f-8771-438a21983a26";
const wman3 = "https://firebasestorage.googleapis.com/v0/b/yo-americano.appspot.com/o/tunetank.com_perfect!-and-fanfare.mp3?alt=media&token=0b543e3c-6bd0-4889-a2f5-d3ed0391b96f";
const wman4 = "https://firebasestorage.googleapis.com/v0/b/yo-americano.appspot.com/o/tunetank.com_trumpet-fanfare-success.mp3?alt=media&token=e45f7655-df78-41fe-840e-4e489d73bde5";
const wman5 = "https://firebasestorage.googleapis.com/v0/b/yo-americano.appspot.com/o/tunetank.com_whistle-funny-siren.mp3?alt=media&token=92691a21-2817-4eb2-bbec-7513720e3d86";
const wman6 = "https://firebasestorage.googleapis.com/v0/b/yo-americano.appspot.com/o/tunetank.com_winner-trumpet-fanfare.mp3?alt=media&token=064a247a-25ac-4e15-876d-47a317fdfed2";
// const monster1= `https://firebasestorage.googleapis.com/v0/b/yo-americano.appspot.com/o/books%2FAudioPicker%2F2025-04-18-31a64989-d92a-4770-bada-c00b6a3e1859tunetank.com_dragon-roar-and-flyby.wav?alt=media&token=635f12e7-0aa6-4eac-830b-8359dc9e498f`;
// const monster2 = `https://firebasestorage.googleapis.com/v0/b/yo-americano.appspot.com/o/books%2FAudioPicker%2F2025-04-18-2646fa78-7cfc-4a47-aee0-527b5bef9b83tunetank.com_monster-breath-1.wav?alt=media&token=f483ba72-9fc3-44ea-8581-123bb239acd1`
// const monster3 = `https://firebasestorage.googleapis.com/v0/b/yo-americano.appspot.com/o/books%2FAudioPicker%2F2025-04-18-7bf6edb7-13d4-4976-9920-c360ed595b97tunetank.com_monster-flying-by.wav?alt=media&token=f9b5dc82-541b-411a-b060-9e15fb1e717f`;
// const monster4 = `https://firebasestorage.googleapis.com/v0/b/yo-americano.appspot.com/o/books%2FAudioPicker%2F2025-04-18-4958dfb2-bcf2-4e81-a419-e6e921790d98tunetank.com_monster-growl-1.wav?alt=media&token=66482913-fb9f-4f63-a3a4-48e333ec7fc7`;
// const monster5 = `https://firebasestorage.googleapis.com/v0/b/yo-americano.appspot.com/o/books%2FAudioPicker%2F2025-04-18-2cad11a5-b97a-4097-a2ee-2349f84711e9tunetank.com_monster-growl-and-flyby.wav?alt=media&token=45087dae-62f0-4759-a542-41c58b807ef3`;
const monster1 = "https://firebasestorage.googleapis.com/v0/b/yo-americano.appspot.com/o/tunetank.com_dragon-roar-and-flyby.mp3?alt=media&token=4f69fdd2-7ed7-4068-8a05-29fa53fc0f79";
const monster2 = "https://firebasestorage.googleapis.com/v0/b/yo-americano.appspot.com/o/tunetank.com_monster-breath-1.mp3?alt=media&token=429ffb49-d78c-4b6e-9138-f515d0943177";
const monster3 = "https://firebasestorage.googleapis.com/v0/b/yo-americano.appspot.com/o/tunetank.com_monster-flying-by.mp3?alt=media&token=bfe5f2cd-7ce4-45df-8fd5-88354ea33558";
const monster4 = "https://firebasestorage.googleapis.com/v0/b/yo-americano.appspot.com/o/tunetank.com_monster-growl-1.mp3?alt=media&token=50209482-260a-4c7c-af59-335ac05027fa";
const monster5 = "https://firebasestorage.googleapis.com/v0/b/yo-americano.appspot.com/o/tunetank.com_monster-growl-and-flyby.mp3?alt=media&token=5176b5d6-fff3-482f-b219-a83e877651c3";
const selectArrow = "https://imagedelivery.net/B62pqpMZqieDKhv80nP5iw/4779b293-21d6-4347-a286-7e58a69ff900/public";
const eyesOpen = "https://firebasestorage.googleapis.com/v0/b/yo-americano.appspot.com/o/picture%2Factivity-submissions%2F2025-08-26-6f6fe976-b546-45c4-94f8-6ca0be8a8277eye.png?alt=media&token=f60802d2-6a93-4c03-b36a-d943e18ebf91";
const OneWay = "https://imagedelivery.net/B62pqpMZqieDKhv80nP5iw/482406d5-8b0a-4ba1-7556-80284958b700/public";
const OneWayEducationLogo = "https://imagedelivery.net/B62pqpMZqieDKhv80nP5iw/ecd47113-57d5-4e6d-dc86-2c2efa4d3e00/public";
const SelectDownArrow = "https://imagedelivery.net/B62pqpMZqieDKhv80nP5iw/993138f8-2a90-4891-c263-fa9ed6f3f400/public";

const goodJob1Gif = cloud_flare_img('50d8ee59-5023-47d4-1187-7a76bbd96900');
const hopeImLateGif = cloud_flare_img('87490b1f-5201-45a7-953b-263fdd2cb800');


export {
  VideoCover,
  eyesOpen,
  NoAssignmentCompletedimg,
  NoAssignmentPastimg,
  NoAssignmentTodayimg,
  NoAssignmentWeekimg,
  Worldimg,
  Worksheetimg,
  Apimg,
  Birdimg,
  BoxSettimgimg,
  Calendarimg,
  CotationBgimg,
  GraphicOrganizerimg,
  HarramientsImg,
  LoadingBgimg,
  Logoimg,
  mobileMenuimg,
  UpdatedAssignableImg,
  NoNotesimg,
  noQuestionimg,
  NoDataTeacherGraphimg,
  Nostroonlineimg,
  NoteIconimg,
  QuestionMarkimg,
  ResourceBgimg,
  SadEmojiimg,
  Tbgimg,
  TbgIconimg,
  TrueMarkimg,
  Ps,
  AuthBG,
  DefaultLogo,
  LoginBg,
  Logo_transparent,
  IntroVideo,
  IntroVideoPoster,
  circural_arrow,
  DistrictBg,
  SimpleLogo,
  Death_Day,
  MenuImg,
  Notesicon,
  Questionicon,
  CologG,
  TableBg,
  BirdLogo,
  ButtonBg,
  ClassLeftImg,
  BirdLogoLarge,
  SelectArrow,
  Pic1,
  blogbanner,
  img34,
  backBg,
  blog,
  bloglink,
  btnBg,
  closeicon,
  closeModal,
  editIcon,
  globeBg3,
  learnImg,
  locationImg,
  locationResource,
  LOGO,
  modalBanner,
  nostroOnline,
  profileArrow,
  resource1,
  userImg,
  UpdatedNoteIcon,
  videoBlog,
  videoImg,
  videoLink,
  LogoOnExam,
  CotationBgimgNew,
  SearchIcon,
  MenuIcon,
  MessageBottal,
  MessageRocket,
  TransparentLogoWhite,
  CatImg,
  CalendarIcon,
  ClockIcon,
  MobIcon,
  IMG_7614,
  IMG_7611,
  IMG_7605,
  IMG_7600,
  IMG_7574,
  IMG_7575,
  IMG_7576,
  IMG_7577,
  IMG_7595,
  IMG_7596,
  WriteEdit,
  WriteEditWhite,
  TrashSvg,
  uploadImg,
  MenuWhiteImg,
  threeDotImg,
  searchIconImage,
  UpdatedAssignedImg,
  AIimg,
  bootImg,
  rootImage,
  colorImg,
  placeImg,
  LoginLogo,
  StarRating,
  personGreen1,
  personGreen2,
  WheelImg,
  WheelTransparentImg,
  WheelClock,
  colorCircle,
  robert2,
  datagrid_close,
  datagrid_colorCombo,
  datagrid_eyeIcon,
  datagrid_logo,
  datagrid_searchIcon,
  datagrid_logoColored,
  pic11,
  pic22,
  pic33,
  pic44,
  pic55,
  DueTodayIcon,
  PastDueTodayIcon,
  IGameAI,
  IGameHome10,
  IGameHome11,
  IGameHome7,
  IGameHome8,
  IGameHome9,
  IGameLogo,
  IGameModalImg,
  IGameModalImgDeck,
  IGameModalImgMobile,
  IGameModalTab,
  IGameRightTick,
  // StudyTest
  ChatMenue,
  Questions,
  Notes,
  UpdatedNoteIconimg,
  Notification,
  oneWayLessonsBalcon,
  oneWayLessonsConectandome,
  oneWayLessonsComunidad,
  IdeaOneWay,
  IdeaAi,
  home_icon,
  GameLogo,
  AIBook,
  AITopic,
  DUMMY_POSTER,
  AIfeebackImage,
  // Debate,
  DebateLftIcon,
  DebateRgtIcon,
  EditDebate,
  DebateComment,
  // DebateOneWayLogo,
  DebateNewLogo,
  CheckListImg,
  bubbleNotes,
  IsolationMode,
  AiFeedbackImage,
  GradCalendar,
  ClassLeftNewImg,
  ClassLeftNewLogo,
  WowAnimation,
  VideoGameDeath,
  SinisterLaugh,
  PunchSound,
  WrongAnswerSound,
  NextLevelSound,
  multiPopSound,
  HappyPopSound,
  gameSplash,
  cars1,
  cars2,
  cars3,
  wman1,
  wman2,
  wman3,
  wman4,
  wman5,
  wman6,
  monster1,
  monster2,
  monster3,
  monster4,
  monster5,
  MascotImage,
  GroupImage,
  FeaturesImage,
  selectArrow,
  goodJob1Gif,
  hopeImLateGif,
  OneWay,
  SelectDownArrow,
  OneWayEducationLogo
};
